import { instance } from "@/apis";
import { useQuery } from "@tanstack/react-query";

export const useChatMemosQuery = ({ chatId }: { chatId: string }) => {
  return useQuery({
    queryKey: ["chat-memos", chatId],
    queryFn: () => instance.get(`/api/df/user/chat/${chatId}/memo`),
    select: (res) => res.data.data,
    enabled: !!chatId,
  });
};
